import React from 'react';
import type { CaseEntryTotals } from '../../../utils/caseEntries';
import type { EstimateTotals } from '../../../utils/caseEstimate';
import { diffTone, formatHoursShort, signedHoursShort, signedKr } from '../../../utils/caseEstimate';
import { formatKr } from '../../../utils/quote';
interface ConsumptionOverviewProps {
  estimate: EstimateTotals | null;
  actual: CaseEntryTotals;
}

/** Kompakt overblik, der kan læses på få sekunder. Beløb ekskl. moms. */
export function ConsumptionOverview({
  estimate,
  actual
}: ConsumptionOverviewProps) {
  const rows = [{
    label: 'Timer',
    est: estimate ? formatHoursShort(estimate.hoursCount) : '',
    reg: formatHoursShort(actual.hoursCount),
    diff: estimate ? actual.hoursCount - estimate.hoursCount : 0,
    diffText: estimate ? signedHoursShort(actual.hoursCount - estimate.hoursCount) : ''
  }, ...([['Materialer', estimate?.materials, actual.materials], ['Kørsel & service', estimate?.travelService, actual.travelService], ['Øvrigt', estimate?.other, actual.other]] as [string, number | undefined, number][]).map(([label, est, reg]) => ({
    label,
    est: estimate ? formatKr(est ?? 0) : '',
    reg: formatKr(reg),
    diff: estimate ? reg - (est ?? 0) : 0,
    diffText: estimate ? signedKr(reg - (est ?? 0)) : ''
  }))];
  const totalDiff = estimate ? actual.subtotal - estimate.subtotal : 0;
  return <div data-id="element-110" data-mp="2l4atsnzuyao">
      <dl className="grid grid-cols-2 gap-x-6 gap-y-4 lg:grid-cols-4" data-id="element-111" data-mp="2kkuuhhwmjza">
        {rows.map(row => <div key={row.label} data-id="element-112" data-mp="3uox57r86rx1d">
            <dt className="text-sm text-ink-muted" data-id="element-113" data-mp="cda7hfp6y3w7">{row.label}</dt>
            <dd className="mt-0.5 flex flex-wrap items-baseline gap-x-1.5 text-[15px] text-ink" data-id="element-114" data-mp="cel6z3blsphi">
              {estimate ? <>
                  <span className="whitespace-nowrap text-ink-muted" data-id="element-115" data-mp="mbznf2xj1e9t">{row.est}</span>
                  <span className="text-ink-faint" aria-hidden="true" data-id="element-116" data-mp="hcmqtqgussu1">→</span>
                  <span className="whitespace-nowrap font-semibold" data-id="element-117" data-mp="ofbfpqcqj8y6">{row.reg}</span>
                  <span className="sr-only" data-id="element-118" data-mp="od72uiwuyzlr"> registreret af {row.est} estimeret</span>
                </> : <span className="font-semibold" data-id="element-119" data-mp="ycpkgspaq9an">{row.reg}</span>}
            </dd>
            {estimate && <dd className={`text-sm ${diffTone(row.diff)}`} data-id="element-120" data-mp="1347lfgrbk9vm">{row.diffText}</dd>}
          </div>)}
      </dl>

      <div className="mt-4 flex flex-wrap items-baseline gap-x-6 gap-y-1 border-t border-line pt-3 text-sm" data-id="element-121" data-mp="181zewf7m441x">
        {estimate ? <>
            <span className="text-ink-muted" data-id="element-122" data-mp="1c6gwc7qi259j">
              Estimeret total <span className="font-medium text-ink" data-id="element-123" data-mp="1h48maw7l3hb3">{formatKr(estimate.subtotal)}</span>
            </span>
            <span className="text-ink-muted" data-id="element-124" data-mp="1m2a6xlknrooo">
              Registreret <span className="font-medium text-ink" data-id="element-125" data-mp="3ivlsrpp79x99">{formatKr(actual.subtotal)}</span>
            </span>
            <span className="text-ink-muted" data-id="element-126" data-mp="3ntdhybygn59r">
              Forskel <span className={`font-semibold ${diffTone(totalDiff)}`} data-id="element-127" data-mp="3nvzzn4f2f15p">{signedKr(totalDiff)}</span>
            </span>
          </> : <span className="text-ink-muted" data-id="element-128" data-mp="3bjnr8nj0j0t2">
            Registreret <span className="font-medium text-ink" data-id="element-129" data-mp="3bi2yn3g9drxu">{formatKr(actual.subtotal)}</span> ekskl. moms
          </span>}
        <span className="text-ink-muted sm:ml-auto" data-id="element-130" data-mp="31lzyg34yw3dj">
          Moms {formatKr(actual.vatAmount)} · Inkl. moms{' '}
          <span className="font-display text-base font-bold text-ink" data-id="element-131" data-mp="34duzw1t0pt7">{formatKr(actual.total)}</span>
        </span>
      </div>
    </div>;
}